import React, { Component, PropTypes } from 'react';

class PagesRoomsAndRates extends Component {
    render() {
        return (
            <div>
                Content of PagesRoomsAndRates
                <hr />
                {this.props.children}
            </div>
        );
    }
}

PagesRoomsAndRates.propTypes = {
    children: PropTypes.element
};

export default PagesRoomsAndRates;



// WEBPACK FOOTER //
// ./src/components/pages/pages/PagesRoomsAndRates.js